/**
 * The venue's free public site host, derived from the app's own origin — the same platform-naming
 * convention `resolveWidgetOrigin` (features/embed/snippet.ts) uses: the app runs at `app.<base>` and
 * every venue site is served at `<slug>.<base>` (e.g. `app.tablebear.dev` → `chez-tanguy.tablebear.dev`).
 * Strips a leading `app.` DNS label to get the base domain; falls back to the full hostname
 * (localhost / a bare host). Pure so it is unit-tested without a DOM.
 */
export function resolveSiteBaseDomain(hostname: string): string {
  return hostname.startsWith("app.") ? hostname.slice("app.".length) : hostname;
}

/** The venue's free public host `<slug>.<base-domain>` (no scheme), e.g. `chez-tanguy.tablebear.dev`. */
export function sitePublicHost(slug: string, hostname: string = window.location.hostname): string {
  return `${slug}.${resolveSiteBaseDomain(hostname)}`;
}

/** The venue's free public URL `https://<slug>.<base-domain>`. */
export function sitePublicUrl(
  slug: string,
  hostname: string = window.location.hostname,
  protocol: string = window.location.protocol,
): string {
  return `${protocol}//${sitePublicHost(slug, hostname)}`;
}
